/**
 * Analytics & error tracking stubs.
 *
 * TO ACTIVATE Sentry + PostHog:
 *   npm install @sentry/react posthog-js
 *   Set REACT_APP_SENTRY_DSN and REACT_APP_POSTHOG_KEY in .env
 *   Uncomment the init block in frontend/src/index.jsx
 *
 * Until then, all calls are safe no-ops.
 */

export function captureException(err, context) {
  if (window.__Sentry__) {
    try { window.__Sentry__.captureException(err, { extra: context }); } catch {}
  }
}

export function captureMessage(msg, level = 'info') {
  if (window.__Sentry__) {
    try { window.__Sentry__.captureMessage(msg, level); } catch {}
  }
}

export function trackEvent(event, properties) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.debug('[DoAr]', event, properties || '');
  }
  if (window.posthog) {
    try { window.posthog.capture(event, properties); } catch {}
  }
}

export function trackPageView(path) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.debug('[DoAr] pageview', path);
  }
  if (window.posthog) {
    try { window.posthog.capture('$pageview', { $current_url: path }); } catch {}
  }
}

export function identifyUser(userId, traits) {
  if (window.posthog) {
    try { window.posthog.identify(userId, traits); } catch {}
  }
  if (window.__Sentry__) {
    try { window.__Sentry__.setUser({ id: userId, ...traits }); } catch {}
  }
}

export function resetUser() {
  if (window.posthog) {
    try { window.posthog.reset(); } catch {}
  }
  if (window.__Sentry__) {
    try { window.__Sentry__.setUser(null); } catch {}
  }
}
